import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper.tsx';

export const ArchiveIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 62 62">
            <path
                fill="currentColor"
                // eslint-disable-next-line
                d="M55 61.72H7c-1.5 0-2.72-1.22-2.72-2.72V17.72H1A.72.72 0 0 1 .28 17V1A.72.72 0 0 1 1 .28h60a.72.72 0 0 1 .72.72v16a.72.72 0 0 1-.72.72h-3.28V59c0 1.5-1.22 2.72-2.72 2.72Zm-49.28-44V59c0 .706.574 1.28 1.28 1.28h48c.706 0 1.28-.574 1.28-1.28V17.72H5.72ZM57 16.28h3.28V1.72H1.72v14.56H57ZM37 31.72H25A4.726 4.726 0 0 1 20.28 27 4.726 4.726 0 0 1 25 22.28h12A4.725 4.725 0 0 1 41.72 27 4.725 4.725 0 0 1 37 31.72Zm-12-8A3.284 3.284 0 0 0 21.72 27 3.284 3.284 0 0 0 25 30.28h12A3.284 3.284 0 0 0 40.28 27c0-1.808-1.47-3.28-3.28-3.28H25Z"
            />
        </svg>
    </IconWrapper>
));
